"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncProgressDialog = SyncProgressDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var building_1 = require("../../../features/apis/building");
var building_area_1 = require("../../../features/apis/building-area");
var meter_1 = require("../../../features/apis/meter");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var hooks_1 = require("../../../store/hooks");
function SyncProgressDialog(props) {
    var clientId = props.clientId, onComplete = props.onComplete;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var hasStarted = (0, react_3.useRef)(false);
    var syncBuildings = (0, building_1.useSyncBuildingFromDTMutation)()[0];
    var syncBuildingAreas = (0, building_area_1.useSyncBuildingAreasFromDTMutation)()[0];
    var syncMeters = (0, meter_1.useSyncMetersFromDTMutation)()[0];
    var _a = (0, react_3.useState)([
        { label: "Syncing Buildings", status: "pending" },
        { label: "Syncing Building Areas", status: "pending" },
        { label: "Syncing Meters", status: "pending" },
    ]), steps = _a[0], setSteps = _a[1];
    var _b = (0, react_3.useState)(false), isDone = _b[0], setIsDone = _b[1];
    var updateStep = function (index, update) {
        setSteps(function (prev) { return prev.map(function (step, i) { return (i === index ? __assign(__assign({}, step), update) : step); }); });
    };
    (0, react_3.useEffect)(function () {
        if (hasStarted.current)
            return;
        hasStarted.current = true;
        function runSync() {
            return __awaiter(this, void 0, void 0, function () {
                var mutations, _i, mutations_1, _a, fn, index, response, error_1, message;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            mutations = [
                                { fn: syncBuildings, index: 0 },
                                { fn: syncBuildingAreas, index: 1 },
                                { fn: syncMeters, index: 2 },
                            ];
                            _i = 0, mutations_1 = mutations;
                            _c.label = 1;
                        case 1:
                            if (!(_i < mutations_1.length)) return [3 /*break*/, 6];
                            _a = mutations_1[_i], fn = _a.fn, index = _a.index;
                            updateStep(index, { status: "in_progress" });
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, fn({ clientId: clientId }).unwrap()];
                        case 3:
                            response = _c.sent();
                            updateStep(index, { status: "success", result: response.content });
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _c.sent();
                            message = ((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _b === void 0 ? void 0 : _b.message) || "Sync failed";
                            updateStep(index, { status: "error", error: message });
                            return [3 /*break*/, 5];
                        case 5:
                            _i++;
                            return [3 /*break*/, 1];
                        case 6:
                            setIsDone(true);
                            onComplete();
                            return [2 /*return*/];
                    }
                });
            });
        }
        runSync();
    }, []);
    var completedCount = steps.filter(function (s) { return s.status === "success" || s.status === "error"; }).length;
    var progressValue = (completedCount / steps.length) * 100;
    var hasErrors = steps.some(function (s) { return s.status === "error"; });
    var statusIcon = function (status) {
        switch (status) {
            case "pending":
                return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:clock-circle-linear", className: "text-lg text-gray-400" });
            case "in_progress":
                return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", className: "animate-spin text-lg text-blue-500" });
            case "success":
                return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-circle-linear", className: "text-lg text-green-500" });
            case "error":
                return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-linear", className: "text-lg text-red-500" });
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-5 p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:cloud-download-linear", className: "text-xl text-blue-600" }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-semibold text-gray-900", children: "Digital Twin Sync" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: isDone ? "Sync complete" : "Syncing resources from Digital Twin..." })] })] }), (0, jsx_runtime_1.jsx)(react_1.Progress, { "aria-label": "Sync progress", value: progressValue, color: isDone ? (hasErrors ? "warning" : "success") : "primary", size: "md", className: "w-full" }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-3", children: steps.map(function (step, index) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3 rounded-lg border border-gray-100 px-4 py-3", children: [statusIcon(step.status), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium ".concat(step.status === "pending" ? "text-gray-400" : "text-gray-900"), children: step.label }), step.status === "success" && step.result && ((0, jsx_runtime_1.jsxs)("p", { className: "text-xs text-gray-500", children: [step.result.created, " created, ", step.result.updated, " updated", step.result.errors > 0 && ", ".concat(step.result.errors, " errors")] })), step.status === "error" && (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-red-500", children: step.error })] })] }, index)); }) }), isDone && ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end border-t border-gray-100 pt-4", children: (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: function () { return dispatch((0, content_dialog_1.closeContentDialogThunk)()); }, children: "Done" }) }))] }));
}
